module.exports = __webpack_public_path__ + "static/media/layoutBackgroundVariant.824b3fb5.webp";